import { MIS_STAFFING_MIS } from '../resources/endPoint';
import { serviceName } from '../resources/serviceConstants';
import {
  appendServiceNameToURL,
  appendServicePortToURL,
} from '../resources/serviceURLs';

/**
 * Builds the base URL for the Staffing MIS API.
 * Used by TableUtility's generalSettings.baseURL.
 */
export const getStaffingMisBaseURL = () => {
  const serviceURL = appendServiceNameToURL(serviceName.PROJECT_MS);
  const servicePort = appendServicePortToURL(serviceName.PROJECT_MS);
  const baseUrl = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

  if (process.env.NODE_ENV === 'production') {
    return `${baseUrl}${serviceURL}/api${MIS_STAFFING_MIS}`;
  }

  return `${baseUrl}:${servicePort}${serviceURL}/api${MIS_STAFFING_MIS}`;
};

/**
 * Request definition for fetching Staffing MIS data.
 */
export const fetchStaffingMisData = (requestBody) => {
  return {
    url: MIS_STAFFING_MIS,
    method: 'post',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: requestBody,
    service: serviceName.PROJECT_MS,
  };
};

/**
 * Request definition for exporting Staffing MIS data.
 */
export const fetchStaffingMisExport = (requestBody) => {
  return {
    url: `${MIS_STAFFING_MIS}/export`,
    method: 'post',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: requestBody,
    service: serviceName.PROJECT_MS,
  };
};
